/**
 * Video Modal.
 *
 * @format
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-namespace */

import React, { useEffect, useState } from 'react';
import { removeTags } from '@services/string-transformation-services';
import { loadVideoScript, stopAllVideos } from '@services/video-services';
import ModalWrapper from '@components/modals/modal-wrapper';
import { getUrlParameter } from '@services/url-services';

declare global {
  interface Window {
    videojs: () => void;
    bc: () => void;
  }
  namespace JSX {
    interface IntrinsicElements {
      'video-js': any;
    }
  }
}

/**
 * Video Props.
 */
type VideoProps = {
  title?: string;
  description?: string;
  linkText: string;
  videoId: string;
  linkType: string;
  videoClasses: string;
  videoModalId?: string;
};

/**
 * Video Modal.
 */
const VideoModal = ({
  title,
  description,
  linkText,
  videoId,
  videoClasses,
  videoModalId,
}: VideoProps): JSX.Element => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const sanitizedVideoId = removeTags(videoId);
  const videoElementId = `video-${sanitizedVideoId}`;

  /**
   * Url Video Check.
   */
  useEffect(() => {
    if (
      getUrlParameter(window.location.href, `show-${videoModalId}`) === 'true'
    ) {
      openVideoModal(null, videoId);
    }
  }, [videoId, videoModalId]);

  /**
   * Open Video Modal.
   */
  const openVideoModal = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent> | null,
    videoId: string
  ): void => {
    event?.preventDefault();
    loadVideoScript(videoId, true);
    setShowModal(true);
  };

  /**
   * Listens for modal closing.
   */
  useEffect(() => {
    if (!showModal) {
      stopAllVideos();
    }
  }, [showModal]);

  return (
    <>
      <button
        type="button"
        className={
          videoClasses.includes('btn') ? videoClasses : `simple-modal-link`
        }
        onClick={(event) => openVideoModal(event, videoElementId)}>
        {linkText}
      </button>

      <ModalWrapper
        showModal={showModal}
        setShowModal={setShowModal}
        className="modal-width-80">
        <>
          <div className="video-container">
            <video-js
              className="video-js vjs-fluid"
              data-account="2418587696001"
              data-player="FoCKoQVZW"
              data-embed="default"
              controls=""
              data-video-id={sanitizedVideoId}
              data-playlist-id=""
              data-application-id=""
              id={videoElementId}
            />
          </div>
          {(title || description) && (
            <>
              {title && <h3 className="text-align-left">{title}</h3>}
              {description && <p>{description}</p>}
            </>
          )}
        </>
      </ModalWrapper>
    </>
  );
};
export default VideoModal;
